import { useAppSelector } from '../../store/hooks';

export const useContainerQuery = () => {
  const containerQueries = useAppSelector(({ containerQueries }) => containerQueries);

  return containerQueries;
};
